import Flickity from 'flickity';

export default class KeyTakeaways {
  constructor() {
    const $els = document.querySelectorAll('.js-key-takeaways');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.flickity = new Flickity($el.querySelector('.js-carousel'), {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      contain: 'true',
      cellAlign: 'center',
      groupCells: true,
    });

    $el.querySelector('.js-next').addEventListener('click', e => {
      e.preventDefault();
      this.flickity.next();
    });

    $el.querySelector('.js-prev').addEventListener('click', e => {
      e.preventDefault();
    this.flickity.previous();
    });
  }
}
